import {EffectCallback, useMemo, useEffect, DependencyList} from 'react';
import {isServer} from 'coreUtils/utils';

/**
 * Suspense friendly useEffect that works both on server side only (a no-op on the client)
 * @param {CallableFunction} fn - effect function
 * @param {Array<any>} deps - deps
 */
const useServerRenderEffect = (fn: EffectCallback, deps: DependencyList): void => {
	// Runs during the server render (effects never run there); the caller's deps, by design.
	// eslint-disable-next-line react-hooks/use-memo, react-hooks/exhaustive-deps
	useMemo(fn, deps);
};

// `isServer` never changes in a process: every render calls the same hook (Rules of Hooks, React Compiler).
export const useServerEffect: (fn: EffectCallback, deps: DependencyList) => void = isServer ? useServerRenderEffect : () => undefined;

/**
 * Suspense friendly useEffect that works both on server and client side
 */
const useClientServerEffect: (fn: EffectCallback, deps: DependencyList) => void = isServer ? useServerRenderEffect : useEffect;

export default useClientServerEffect;
